import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgShieldIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4Zm-1.2 14.6L7 11.8l1.4-1.4 2.4 2.4 5-5L17.2 9.2l-6.4 6.4Z"
      fill="currentColor"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgShieldIcon);
export default ForwardRef;
